import { render, staticRenderFns } from "./StakingRecords.vue?vue&type=template&id=7d188762&scoped=true"
import script from "./StakingRecords.vue?vue&type=script&lang=js"
export * from "./StakingRecords.vue?vue&type=script&lang=js"
import style0 from "./StakingRecords.vue?vue&type=style&index=0&id=7d188762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d188762",
  null
  
)

export default component.exports